import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStarOfLife, faArrowRight, faClock, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import styles from "./Landing.module.css";

const HeroSection = ({ featuredBlog }) => {
  const blog = featuredBlog || {
    title: "Why Physiotherapy Is More Than Pain Relief",
    url: "https://www.moveforwardpt.com",
    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=800&q=80",
    body: "Physiotherapy transcends short-term pain intervention. It is a multi-disciplinary, proactive, and educational approach to restoring movement, function, and wellbeing for all ages.",
    source: "Move Forward PT",
    time: "Today",
  };

  return (
    <section className={styles.heroSection}>
      {/* Left Column: Headline & CTA */}
      <div className={styles.heroLeft}>
        <div className={styles.heroBadge}>

          <span>GOLD-STANDARD REHAB & CARE</span>
        </div>

        <h1 className={styles.heroHeadline}>
          Book Your appointment <span>now !</span> Click on Login
        </h1>

        <p className={styles.heroSubline}>
          Empowering your recovery journey with advanced, evidence-backed physiotherapy treatments in Gurugram. Restore mobility, eliminate chronic pain, and rebuild strength.
        </p>

        <div className={styles.heroActions}>
          {/* Primary Action */}
          <Link to="/login" className={styles.ctaPrimary}>
            <span>Book Appointment</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>

          {/* Premium Typographic OR */}
          <div className={styles.elegantOr}>OR</div>

          {/* Naked, High-End Call Link */}
          <a href="tel:+919024989935" className={styles.premiumCallLink}>
            <div className={styles.callRing}>
              <FontAwesomeIcon icon={faPhoneAlt} />
            </div>
            <div className={styles.callTextData}>
              <span className={styles.callSub}>Call us now </span>
              <span className={styles.callNum}>+91 9024989935</span>
            </div>
          </a>
        </div>
      </div>

      {/* Right Column: Featured Overlapping Card */}
      <div className={styles.heroRight}>
        {/* Eye-Catching Trust Badge Cluster with Behind-Glass Aurora & Graffiti */}
        <Link
          to="/reviews"
          className={styles.trustBadgeWrap}
          style={{ textDecoration: "none", display: "block", cursor: "pointer" }}
          aria-label="View Patient Reviews"
        >
          {/* Ambient Glowing Aurora Blob behind glass */}
          <div className={styles.trustAuroraBlob} />

          {/* Graffiti Geometric Accent Doodles */}
          <div className={styles.trustGraffitiDots} />
          <div className={styles.trustSparkleAccent}>✦</div>

          {/* Floating Glass Trust Pill */}
          <div className={styles.trustCluster}>
            <div className={styles.avatarCluster}>
              <img
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80"
                alt="Verified Patient Face 1"
                className={styles.trustAvatar}
              />
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80"
                alt="Verified Patient Face 2"
                className={styles.trustAvatar}
              />
              <img
                src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=150&q=80"
                alt="Verified Patient Face 3"
                className={styles.trustAvatar}
              />
            </div>

            <div className={styles.trustTextData}>
              <div className={styles.trustTopLine}>
                <span className={styles.trustStars}>★★★★★</span>
                <span className={styles.trustScore}>4.5+ / 5</span>
              </div>
              <div className={styles.trustBottomLine}>VERIFIED ACROSS ALL PLATFORMS & SOURCES</div>
            </div>
          </div>
        </Link>

        <a
          href={blog.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.featuredCard}
        >
          <div className={styles.featuredImageWrap}>
            <img src={blog.image} alt={blog.title} />
          </div>

          <div className={styles.featuredCardBody}>
            <div className={styles.featuredMeta}>
              <span>FEATURED ARTICLE • {blog.source}</span>
              <span>
                <FontAwesomeIcon icon={faClock} /> {blog.time}
              </span>
            </div>

            <h2 className={styles.featuredTitle}>{blog.title}</h2>

            <p className={styles.featuredExcerpt}>{blog.body}</p>

            <div className={styles.cardCta}>
              <span>Read Full Article</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
